<template>
  <div class="p-3" style="width: 400px; margin: 50px auto; border: 1px solid #f2f2f2; box-sizing: content-box">
    <div class="btnWrap">
      <div
        v-for="btn in calcBtns"
        :key="btn"
        class="lead bg-vue-dark rounded btn-hover"
        :class="{ 'bg-vue-green': ['(', '*', '/', '+', '-', ')', '%'].includes(btn) }"
        @click="action(btn)"
      >
        {{ btn }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Calculator",

  data() {
    return {
      calcVal: "",
      calcBtns: ["(", ")", "%", "+", 7, 8, 9, "-", 4, 5, 6, "*", 1, 2, 3, "/", 0, "."],
      operators: null,
      prevCalcVal: ""
    };
  },
  methods: {
    action(btn) {
      this.$emit("action", {
        value: btn,
        type: "keyboard"
      });
    }
  }
};
</script>

<style scoped>
.btnWrap {
  display: flex;
  flex-wrap: wrap;
  color: #fff;
}
.bg-vue-dark {
  color: #333;
  background: #d7d7d7;
}
.lead {
  font-size: 16px;
  font-weight: 300;
  width: 80px;
  height: 30px;
  line-height: 30px;
  margin: 10px;
  border-radius: 2px;
  text-align: center;
}

.bg-vue-green {
  background: var(--theme-color);
  color: #fff;
}
</style>
